module.exports = __webpack_public_path__ + "img/classify_13.4e1da007.png";